import { createCrudHooks } from "../common/queries";

export const schoolApi = createCrudHooks({
	baseKey: "schools",
	basePath: "/schools",
	getAllParams: { include: [{ association: 'students', include: ['enrollments'] }, { association: 'users' }] },
	getParams: { include: [{ association: 'students', include: ['enrollments'] }, { association: 'users' }] },
});
